import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Input,
  FormGroup,
  Table,
  Nav,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Modal,
} from "reactstrap";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Navigate, useNavigate } from "react-router-dom";
//constant
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { requestApi } from "../../../request-api";
import DataTable from "react-data-table-component";
import { API_URL } from "../../../config";
import axios from "axios";
import { userStore } from "../../../stores";
import { dataToXLS } from "../../../helpers/dataToXLS";
import VisibilityIcon from "@mui/icons-material/Visibility";

// toaster
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import JSZip from "jszip";
import FileSaver from "file-saver";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import autoTable from "jspdf-autotable";
import Dropdown from "../../layouts/dropdown/Dropdown";
import ActDropdown from "../../layouts/dropdown/ActDropdown";
//import * as XLSX from "xlsx";
import { method } from "lodash";
import {
  endOfLocalDay,
  formatLocalYmd,
  isLocalDateInRange,
  parseLocalYmd,
  startOfLocalDay,
} from "../../../helpers/complianceDashboard";
function CompliancerReports() {
  let navigate = useNavigate();
  let [checked, setChecked] = useState(false);
  const [searchStatus, setSearchStatus] = useState("");
  let [isChecked, setIsChecked] = useState(false);
  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [startDate, setStartDate] = useState(defaultStart);
  const [report, setReport] = useState([]);
  const [shareApprover, setShareApprover] = useState();
  const [search, setSearch] = useState("");
  let [companyFilter, setCompanyFilter] = useState([]);
  let [branchFilter, setBranchFilter] = useState([]);
  let [reportFilter, setReportFilter] = useState([]);
  let [downloadData, setDownloadData] = useState([]);
  let [loading, setLoading] = useState(false);
  let [modal, setModal] = useState(false);
  const toggleDropdown2 = () => setShowDropdown(!showDropdown);
  const dateDropdownRef = useRef(null);


  const [showDropdown, setShowDropdown] = useState(false);
  const [format, setFormat] = useState(null);
  const [period, setPeriod] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [isOpen1, setIsOpen1] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems1, setSelectedItems1] = useState([]);
  const [search1, setSearch1] = useState(""); // You can make this dynamic
  const [acts, setActs] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedRange, setSelectedRange] = useState("This Month");
  const [selectedActs, setSelectedActs] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [searchActs, setSearchActs] = useState("");
  const [searchLocations, setSearchLocations] = useState("");
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);
  const [sortType, setSortType] = useState("none");
  const [functionHeadName, setFunctionHeadName] = useState("Bhatt and Karle Associates Private Limted");
  const [designation, setDesignation] = useState("Compliance Officer");
  const [showModall, setShowModall] = React.useState(false);
  const [complianceData, setComplianceData] = React.useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);


  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  // Close dropdown when clicking outside

  const [visibleColumns, setVisibleColumns] = useState({
    srNo: true,
    entity: true,
    branch: true,
    legislation: true,
    complianceDetails: true,
    dateOfCompliance: true,
    score: true,
    dueDate: true,
    auditor: true,
    complianceStatus: true,
  });

  // Toggle column visibility
  const toggleColumn = (col) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [col]: !prev[col],
    }));
  };
  const handleShowAllColumns = () => {
    setVisibleColumns((prev) =>
      Object.keys(prev).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {})
    );
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen1(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchReports = async () => {
    try {
      const res = await requestApi("/report/reportscomp", { method: "get" });
      setReportData(res);

      // Extract unique company names from the fetched reports
      const companyNames = [
        ...new Set(res.map((report) => report.companyName)),
      ];
      const uniqueActs = [
        ...new Set(res.map((item) => item.act).filter(Boolean)),
      ];
      const uniqueLocations = [
        ...new Set(res.map((item) => item.branchName).filter(Boolean)),
      ];
      const uniqueSubBranches = [
        ...new Set(res.map((item) => item.sub_branch).filter(Boolean)),
      ];
      setAvailableSubBranches(uniqueSubBranches);

      setActs(uniqueActs);
      setLocations(uniqueLocations);
      setCompanies(companyNames.filter(Boolean)); // Filter out empty/null names
    } catch (err) {
      console.error("Failed to fetch reports:", err);
    }
  };


  const handleGeneratePDF = async () => {
    const content = document.getElementById("certificate-content");
    if (!content) {
      alert("Certificate content not found!");
      return;
    }

    // Temporarily place on-screen so html2canvas measures layout correctly
    const previousStyles = {
      position: content.style.position,
      left: content.style.left,
      top: content.style.top,
      zIndex: content.style.zIndex,
    };
    content.style.position = "fixed";
    content.style.left = "0";
    content.style.top = "0";
    content.style.zIndex = "-1";

    try {
      const canvas = await html2canvas(content, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        scrollX: 0,
        scrollY: 0,
        windowWidth: content.scrollWidth,
        windowHeight: content.scrollHeight,
      });

      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const usableWidth = pageWidth - margin * 2;
      const usableHeight = pageHeight - margin * 2;

      const pxPerMm = canvas.width / usableWidth;
      const pageHeightPx = Math.floor(usableHeight * pxPerMm);

      /**
       * Prefer breaking on a mostly-white row so tables/text are not sliced.
       * Searches upward from the ideal cut within `searchWindow` pixels.
       */
      const findSafeBreak = (sourceCanvas, startY, idealEndY, searchWindow = 80) => {
        if (idealEndY >= sourceCanvas.height) return sourceCanvas.height;

        const ctx = sourceCanvas.getContext("2d");
        const minY = Math.max(startY + 20, idealEndY - searchWindow);

        for (let y = idealEndY; y >= minY; y -= 1) {
          const row = ctx.getImageData(0, y, sourceCanvas.width, 1).data;
          let darkPixels = 0;
          // Sample every 8th pixel for speed
          for (let i = 0; i < row.length; i += 32) {
            const r = row[i];
            const g = row[i + 1];
            const b = row[i + 2];
            const a = row[i + 3];
            if (a > 10 && (r < 245 || g < 245 || b < 245)) {
              darkPixels += 1;
              if (darkPixels > 2) break;
            }
          }
          if (darkPixels <= 2) return y + 1;
        }

        return idealEndY;
      };

      let y = 0;
      let pageIndex = 0;

      while (y < canvas.height) {
        const idealEnd = Math.min(y + pageHeightPx, canvas.height);
        const breakAt =
          idealEnd >= canvas.height
            ? canvas.height
            : findSafeBreak(canvas, y, idealEnd);

        const sliceHeight = Math.max(1, breakAt - y);
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sliceHeight;

        const sliceCtx = sliceCanvas.getContext("2d");
        sliceCtx.fillStyle = "#ffffff";
        sliceCtx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
        sliceCtx.drawImage(
          canvas,
          0,
          y,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        const sliceData = sliceCanvas.toDataURL("image/png");
        const sliceImgHeight = sliceHeight / pxPerMm;

        if (pageIndex > 0) pdf.addPage();
        pdf.addImage(
          sliceData,
          "PNG",
          margin,
          margin,
          usableWidth,
          sliceImgHeight
        );

        y = breakAt;
        pageIndex += 1;

        // Safety against infinite loops on bad break detection
        if (pageIndex > 50) break;
      }

      pdf.save(`${selectedCompany}_ComplianceCertificate.pdf`);
    } catch (err) {
      console.error("Certificate PDF generation failed:", err);
      toast.error("Failed to generate certificate PDF.");
    } finally {
      content.style.position = previousStyles.position;
      content.style.left = previousStyles.left;
      content.style.top = previousStyles.top;
      content.style.zIndex = previousStyles.zIndex;
    }
  };

  console.log("Selected Company:", selectedCompany);
  console.log("Selected SubBranches:", selectedSubBranches);
  console.log(
    "Available Sub Branches:",
    reportData.map((r) => r.sub_branch)
  );

  //console.log("Company Acts:", companyActs);

  const filterDataByPeriod = (data, selectedPeriod) => {
    const now = new Date();

    let fromDate = new Date();
    if (selectedPeriod === "Monthly") {
      fromDate.setMonth(now.getMonth() - 1);
    } else if (selectedPeriod === "Quarterly") {
      fromDate.setMonth(now.getMonth() - 3);
    } else if (selectedPeriod === "Semi-Annually") {
      fromDate.setMonth(now.getMonth() - 6);
    } else if (selectedPeriod === "Annually") {
      fromDate.setFullYear(now.getFullYear() - 1);
    }

    return data.filter((item) => {
      const reportDate = new Date(item.auditedDate);
      return reportDate >= fromDate && reportDate <= now;
    });
  };

  const filterByDueDateRange = (data, fromDate, toDate) => {
    if (!fromDate && !toDate) return data;

    return data.filter((item) => {
      if (!item.dueDate) return false;

      const due = startOfLocalDay(item.dueDate);
      if (!due) return false;

      const from = fromDate ? startOfLocalDay(fromDate) : null;
      const to = toDate ? endOfLocalDay(toDate) : null;

      return (!from || due >= from) && (!to || due <= to);
    });
  };


  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "NA"; // invalid date check
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleExport = () => {
    // Step 1: Filter by selected period
    let exportData = [...filteredReports]; // 👈 SAME DATA AS TABLE

    exportData = exportData.map((item, index) => {
      const status = (item.currentstatus || "").toLowerCase().trim();

      let score = "";
      if (status === "complied") score = 1;
      else if (status === "not complied") score = 0;
      else if (status === "partial complied") score = 0.5;
      else if (status === "not applicable") score = 0;

      return {
        ...item,
        score,
        serialNumber: index + 1,
      };
    });
    // if (selectedSubBranches && selectedSubBranches.length > 0) {
    //   filteredData = filteredData.filter((item) =>
    //     selectedSubBranches.includes(item.sub_branch)
    //   );
    // }

    // PDF Export
    const exportDataWithSerial = exportData;

    if (format === "pdf") {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });
      doc.text("Compliance Report", 14, 15);

      autoTable(doc, {
        startY: 20,
        head: [
          [
            "Sr No",
            "Entity",
            "Branch Name",
            "Legislation",
            "Compliance Details",
            "Score",
            "Due Date",
            "Auditor",
            "Summary of Observation",
            "Management Remarks",
            "Additional Information",
            "Knowledge Bank",
            "Compliance Status",
          ],
        ],
        body: exportDataWithSerial.map((item) => [
          item.serialNumber,
          item.companyName,
          item.branchName,
          item.act,
          item.desc,
          item.score,
          formatDate(item.dueDate),
          item.assignedAuditor,
          item.summary_of_observation,
          item.management_remark,
          item.additional_information,
          item.knowledge_bank,
          item.currentstatus,
        ]),
        styles: {
          fontSize: 8,
          cellPadding: 2,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          4: { halign: "center" },
          5: { halign: "center" },
          7: { halign: "center" },
        },
        theme: "grid",
        margin: { left: 10, right: 10 },
        tableWidth: "auto",
      });

      doc.save("ComplianceReport.pdf");
    }

    // Excel Export
    if (format === "excel") {
      const sheetData = [
        [
          "Sr No",
          "Entity",
          "Branch Name",
          "Legislation",
          "Compliance Details",
          "Compliance ID ",
          "Provision",
          "Penalty Type",
          "Penalty Description",
          "Proof Mandatory",
          "Score",
          "Criticality",
          "Due Date",
          "Audited Date",
          "Auditor",
          "Summary of Observation",
          "Management Remarks",
          "Additional Information",
          "Knowledge Bank",
          "Date of Compliance",
          "Compliance Officer",
          "Compliance Status",
          "Location",
          "Sub Branch",
          "Created At",
        ],
        ...exportDataWithSerial.map((item) => [
          item.serialNumber,
          item.companyName,
          item.branchName,
          item.act,
          item.desc,
          item.compd,
          item.provision,
          item.penalty_type,
          item.penalty_description,
          item.proof_mandatory,
          item.score,
          item.criticality,
          formatDate(item.dueDate),
          formatDate(item.auditedDate),
          item.assignedAuditor,
          item.summary_of_observation,
          item.management_remark,
          item.additional_information,
          item.knowledge_bank,
          formatDate(item.period),
          item.complianceOfficer,
          item.currentstatus,
          item.location,
          item.sub_branch,

          formatDate(item.created_at),
        ]),
      ];

      const uniqueCompanies = [
        ...new Set(
          exportDataWithSerial.map((item) => item.companyName).filter(Boolean)
        ),
      ];
      let companyNameText = "";
      if (uniqueCompanies.length > 0) {
        companyNameText = uniqueCompanies.join(", ");
      } else if (typeof selectedCompany !== "undefined" && selectedCompany) {
        companyNameText = selectedCompany;
      } else if (typeof selectedItems !== "undefined" && selectedItems && selectedItems.length > 0) {
        companyNameText = selectedItems.join(", ");
      } else {
        companyNameText = "Company Name";
      }

      const locationList = [
        ...new Set(
          exportDataWithSerial.map((item) => item.location).filter(Boolean)
        ),
      ];
      let locationText = "";
      if (locationList.length > 0) {
        locationText = locationList.join(", ");
      } else if (typeof selectedLocations !== "undefined" && selectedLocations && selectedLocations.length > 0) {
        locationText = selectedLocations.join(", ");
      } else {
        locationText = "All Locations";
      }

      let dateRangeText = "";
      if (startDate && endDate) {
        dateRangeText = `${formatDate(startDate)} to ${formatDate(endDate)}`;
      } else if (period) {
        dateRangeText = period;
      } else {
        dateRangeText = "All";
      }

      const getColumnLetter = (colIndex) => {
        let temp,
          letter = "";
        while (colIndex > 0) {
          temp = (colIndex - 1) % 26;
          letter = String.fromCharCode(65 + temp) + letter;
          colIndex = (colIndex - temp - 1) / 26;
        }
        return letter;
      };

      const totalCols = sheetData[0].length;
      const lastColLetter = getColumnLetter(totalCols);
      const totalRows = 3 + sheetData.length;

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData, { origin: "A4" });

      const colWidths = sheetData[0].map((header) => ({
        wch: Math.max(String(header).length + 5, 18),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      XlsxPopulate.fromDataAsync(wbout)
        .then((wb) => {
          const sheet = wb.sheet(0);

          // 1. Row 1: Company Name (Left Aligned)
          const companyRange = sheet.range(`A1:${lastColLetter}1`);
          companyRange.merged(true);
          sheet.cell("A1").value(`Company Name: ${companyNameText}`);
          companyRange.style({
            bold: true,
            fontSize: 14,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 2. Row 2: Location (Left Aligned)
          const locationRange = sheet.range(`A2:${lastColLetter}2`);
          locationRange.merged(true);
          sheet.cell("A2").value(`Location: ${locationText}`);
          locationRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 3. Row 3: Period (Left Aligned)
          const dateRange = sheet.range(`A3:${lastColLetter}3`);
          dateRange.merged(true);
          sheet.cell("A3").value(`Period: ${dateRangeText}`);
          dateRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
          sheet.range(`A4:${lastColLetter}4`).style({
            bold: true,
            fontSize: 12,
            wrapText: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
            fill: "D9E1F2",
            border: true,
          });

          // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
          if (totalRows >= 5) {
            sheet.range(`A5:${lastColLetter}${totalRows}`).style({
              wrapText: true,
              fontSize: 10,
              verticalAlignment: "center",
              border: true,
            });
          }

          return wb.outputAsync();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = `report_${period}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        });
    }

    setShowDropdown(false);
    setFormat(null);
    setPeriod(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchReports();
    setCurrentPage(1);
  }, []);

  const calculateComplianceScore = (data) => {
    let numerator = 0;
    let denominator = 0;

    data.forEach((item) => {
      const status = item.currentstatus?.toLowerCase();

      switch (status) {
        case "compiled":
          numerator += 1;
          denominator += 1;
          break;
        case "not complied":
          denominator += 1;
          break;
        case "partial compiled":
          numerator += 0.5;
          denominator += 1;
          break;
        case "not applicable":
          break; // skip
        default:
          break; // unknown statuses
      }
    });

    const scorePercent =
      denominator === 0 ? 0 : ((numerator / denominator) * 100).toFixed(2);

    return {
      numerator,
      denominator,
      scorePercent,
    };
  };

  const getDateRange = (range) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let start = null;
    let end = null;

    switch (range) {
      case "This Month":
        const now = new Date();
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);
        break;

      case "Today":
        start = new Date(today);
        end = new Date(today);
        end.setHours(23, 59, 59, 999);
        break;

      case "Yesterday": {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        start = new Date(yesterday);
        end = new Date(yesterday);
        end.setHours(23, 59, 59, 999);
        break;
      }

      case "Last 7 days":
        start = new Date(today);
        start.setDate(today.getDate() - 6);
        end = new Date();
        end.setHours(23, 59, 59, 999);
        break;

      case "Last 30 days":
        start = new Date(today);
        start.setDate(today.getDate() - 29);
        end = new Date();
        end.setHours(23, 59, 59, 999);
        break;

      default:
        // Custom range — parse YYYY-MM-DD as local dates, never UTC
        if (typeof range === "string" && range.includes(" - ")) {
          const [startStr, endStr] = range.split(" - ");
          start = parseLocalYmd(startStr);
          end = endOfLocalDay(parseLocalYmd(endStr));
        }
        break;
    }

    return { start, end };
  };

  const handleDateQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "This Month":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setSelectedRange("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setStartDate(start);
    setEndDate(end);
    setSelectedRange(type);
    setIsOpen(false); // Close dropdown when quick filter is selected
  };

  const applyDateFilter = () => {
    if (startDate && endDate) {
      const start = startOfLocalDay(startDate);
      const end = endOfLocalDay(endDate);
      setStartDate(start);
      setEndDate(end);
      setSelectedRange(`${formatLocalYmd(start)} - ${formatLocalYmd(end)}`);
      setIsOpen(false);
    }
  };


  const normalizeDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };



  const filteredReports = reportData.filter((report) => {
    // ---------- DATE FILTER (local calendar day, same as picker) ----------
    if (startDate && endDate) {
      if (!isLocalDateInRange(report.dueDate, startDate, endDate)) {
        return false;
      }
    }

    // ---------- OTHER FILTERS ----------
    return (
      (selectedItems.length === 0 ||
        selectedItems.includes(report.companyName)) &&
      (selectedActs.length === 0 ||
        selectedActs.includes(report.act)) &&
      (selectedLocations.length === 0 ||
        selectedLocations.includes(report.branchName)) &&
      (selectedSubBranches.length === 0 ||
        selectedSubBranches.includes(report.sub_branch))
    );

  });


  const companyReports = reportData.filter(
    (r) =>
      r.companyName === selectedCompany &&
      (selectedSubBranches.length === 0 ||
        selectedSubBranches.includes(r.sub_branch))
  );
  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const companyActs = filteredReports
    .filter((r) => r.companyName === selectedCompany)
    .map((r) => r.act)
    .filter((act, index, self) => act && self.indexOf(act) === index);

  console.log("Company Acts", companyActs);

  const sortedReports = [...filteredReports];
  const criticalityOrder = {
    Low: 1,
    Medium: 2,
    High: 3,
  };
  if (sortType === "alpha") {
    sortedReports.sort((a, b) => a.act.localeCompare(b.act));
  } else if (sortType === "reverse-alpha") {
    sortedReports.sort((a, b) => b.act.localeCompare(a.act));
  } else if (sortType === "due-asc") {
    sortedReports.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));
  } else if (sortType === "due-desc") {
    sortedReports.sort((a, b) => new Date(b.dueDate) - new Date(a.dueDate));
  } else if (sortType === "criticality-asc") {
    sortedReports.sort(
      (a, b) =>
        (criticalityOrder[a.criticality] || 0) -
        (criticalityOrder[b.criticality] || 0)
    );
  } else if (sortType === "criticality-desc") {
    sortedReports.sort(
      (a, b) =>
        (criticalityOrder[b.criticality] || 0) -
        (criticalityOrder[a.criticality] || 0)
    );
  }

  // Pagination
  const indexOfLastReport = currentPage * itemsPerPage;
  const indexOfFirstReport = indexOfLastReport - itemsPerPage;
  const currentReports = sortedReports.slice(
    indexOfFirstReport,
    indexOfLastReport
  );

  const totalPages = Math.ceil(filteredReports.length / itemsPerPage);

  const toggleSelection = (company) => {
    if (selectedItems.includes(company)) {
      setSelectedItems(selectedItems.filter((item) => item !== company));
    } else {
      setSelectedItems([...selectedItems, company]);
    }
  };

  const toggleActSelection = (act) => {
    setSelectedActs((prev) =>
      prev.includes(act) ? prev.filter((a) => a !== act) : [...prev, act]
    );
  };
  const toggleLocationSelection = (location) => {
    setSelectedLocations((prev) =>
      prev.includes(location)
        ? prev.filter((l) => l !== location)
        : [...prev, location]
    );
  };
  const toggleSelectAllActs = () => {
    if (selectedActs.length === acts.length) {
      setSelectedActs([]);
    } else {
      setSelectedActs(acts);
    }
  };
  const toggleSelectAllLocations = () => {
    if (selectedLocations.length === locations.length) {
      setSelectedLocations([]);
    } else {
      setSelectedLocations(locations);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedRange,
    selectedItems,
    selectedActs,
    selectedLocations,
    selectedSubBranches,
    sortType
  ]);

  const [companies, setCompanies] = useState([]);
  const companies1 = ["Thane", "Vashi", "Kurla", "NaviMumbai", "Dadar"];
  // const [startDate, setStartDate] = useState(null);

  // const toggleSelection = (company) => {
  //   if (selectedItems.includes(company)) {
  //     setSelectedItems(selectedItems.filter((item) => item !== company));
  //   } else {
  //     setSelectedItems([...selectedItems, company]);
  //   }
  // };
  const toggleSelection1 = (item) => {
    setSelectedItems1((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };
  const toggleDropdown = () => setShowDropdown(!showDropdown);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown1 = () => {
    setShowDropdown((prev) => !prev);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  const [showCertificateDropdown, setShowCertificateDropdown] = useState(false);
  const [certificateFormat, setCertificateFormat] = useState(null);
  const [certificatePeriod, setCertificatePeriod] = useState(null);

  const toggleCertificateDropdown = () => {
    setShowCertificateDropdown((prev) => !prev);
  };

  const getPageNumbers = (totalPages, currentPage) => {
    if (totalPages <= 1) return [1];

    const delta = 2;
    const range = [];
    const rangeWithDots = [];
    let last;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (last) {
        if (i - last === 2) {
          rangeWithDots.push(last + 1);
        } else if (i - last > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      last = i;
    }

    return rangeWithDots;
  };

  const pageNumbers = getPageNumbers(totalPages, currentPage);


  // const pageNumbers = getPageNumbers(totalPages, currentPage);
  // const pageNumbers = getPageNumbers(totalPages, currentPage);
  const handleGenerateCertificate = () => {
    console.log("Format:", certificateFormat);
    console.log("Period:", certificatePeriod);
  };

  return (
    <section className=" bs-table lyt-section typ-min-height p-5">

      <div className="">
        <div className="card">
          <div className="  ">

            <div className="table-responsive  typ-comman-he p-4">

              <div className="d-flex w-100 justify-content-between mb-2 ">
                <div className="d-flex gap-2 ">
                  <Dropdown
                    label="Select Company Name"
                    options={companies}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                  />

                  <Dropdown
                    label="Sub Branch"
                    options={availableSubBranches}
                    selectedItems={selectedSubBranches}
                    setSelectedItems={setSelectedSubBranches}
                  />

                  <ActDropdown
                    label="Select Acts"
                    availableActs={acts}
                    selectedActs={selectedActs}
                    setSelectedActs={setSelectedActs}
                  />

                  <Dropdown
                    label="Select Locations"
                    options={locations}
                    selectedItems={selectedLocations}
                    setSelectedItems={setSelectedLocations}
                  />

                  <div className="position-relative d-inline-block " ref={dateDropdownRef}>
                    <button
                      className="btn bg-white border border-secondary-subtle d-flex align-items-center gap-2 w-20"
                      type="button"
                      data-bs-toggle="dropdown"

                      onClick={() => setIsOpen(!isOpen)}
                      aria-expanded={isOpen}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                        alt="Calendar Icon"
                        width="16"
                        height="16"
                      />
                      <span className="fs-12">
                        {startDate && endDate
                          ? `${startDate.toLocaleDateString("en-GB")} - ${endDate.toLocaleDateString("en-GB")}`
                          : selectedRange || "Select Date"}
                      </span>
                    </button>
                    {isOpen && (
                      <div
                        className="position-absolute mt-2 bg-white border shadow p-3"
                        style={{
                          zIndex: 1000,
                          width: "693px",   // fixed, zoom-safe
                          maxWidth: "95vw", // responsive
                          right: 0,
                          overflow: "hidden",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-3">
                            <ul className="list-group">
                              <li
                                className="list-group-item bg-light rounded fs-12"
                                onClick={() => handleDateQuickFilter("This Month")}
                              >
                                This Month
                              </li>
                              <li
                                className="list-group-item fs-12"
                                style={{ border: "none" }}
                                onClick={() => handleDateQuickFilter("Today")}
                              >
                                Today
                              </li>
                              <li
                                className="list-group-item fs-12"
                                style={{ border: "none" }}
                                onClick={() => handleDateQuickFilter("Yesterday")}
                              >
                                Yesterday
                              </li>
                              <li
                                className="list-group-item fs-12"
                                style={{ border: "none" }}
                                onClick={() => handleDateQuickFilter("Last 7 days")}
                              >
                                Last 7 days
                              </li>
                              <li
                                className="list-group-item fs-12"
                                style={{ border: "none" }}
                                onClick={() => handleDateQuickFilter("Last 30 days")}
                              >
                                Last 30 days
                              </li>
                              <li
                                className="list-group-item  fs-12"
                                style={{ border: "none" }}
                                onClick={() => handleDateQuickFilter("Manual")}
                              >
                                Manual
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-9 border-start">
                            {selectedRange === "Manual" && (
                            <>
                              <div className="d-flex justify-content-between fs-12"></div>
                              <div className="row">
                                <div className="col-md-6">
                                  <DatePicker
                                    selected={startDate}
                                    onChange={(date) =>
                                      setStartDate(date ? startOfLocalDay(date) : date)
                                    }
                                    inline
                                  />
                                </div>
                                <div className="col-md-6">
                                  <DatePicker
                                    selected={endDate}
                                    onChange={(date) =>
                                      setEndDate(date ? endOfLocalDay(date) : date)
                                    }
                                    inline
                                  />
                                </div>
                              </div>
                            </>
                            )}
                            <div className="mt-3 d-flex justify-content-between align-items-center">
                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}
                                id="selected-range"
                                className="btn dashboard"
                              >
                                <span id="start-display" style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}>
                                  {startDate
                                    ? startDate.toLocaleDateString("en-GB")
                                    : "Start Date"}
                                </span>
                                <span style={{ fontSize: "16px" }}> → </span>
                                <span id="end-display" style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}>
                                  {endDate
                                    ? endDate.toLocaleDateString("en-GB")
                                    : "End Date"}
                                </span>
                              </div>
                              <button
                                className="btn btn-dark fs-12"
                                disabled={!startDate || !endDate}
                                onClick={applyDateFilter}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="d-flex gap-2 ">
                  <div className="">
                    <button
                      className="btn  fh"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{
                        border: "1px solid #E4E4E7",
                        backgroundColor: "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "12px",
                        fontWeight: "500",
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3 3h10v1H3V3zm0 3h7v1H3V6zm0 3h4v1H3V9zm8 2h3v-3h1v3h3l-3.5 3.5L11 11z" />
                      </svg>
                    </button>

                    <ul className="dropdown-menu p-2 shadow">
                      <li>
                        <button
                          className="dropdown-item fs-12"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("none")}
                        >
                          No Sorting
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2 fs-12"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("reverse-alpha")}
                        >
                          Reverse Alphabetical
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            Z-A
                          </span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2 fs-12"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("alpha")}
                        >
                          Alphabetical
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            A-Z
                          </span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2 fh "
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("due-asc")}
                        >
                          Due Date - Ascending
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            1-9
                          </span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("due-desc")}
                        >
                          Due Date - Descending
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            9-1
                          </span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("criticality-asc")}
                        >
                          Criticality
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            Low-High
                          </span>
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item d-flex justify-content-between pt-2"
                          style={{ fontSize: "9px", minWidth: "120px" }}
                          onClick={() => setSortType("criticality-desc")}
                        >
                          Criticality
                          <span
                            className="text-muted"
                            style={{ fontSize: "9px" }}
                          >
                            High-Low
                          </span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="position-relative" ref={dropdownRef}>
                    <button
                      className="btn fh "
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{
                        border: "1px solid #E4E4E7",
                        backgroundColor: "#FFFFFF",
                        color: "#1F1F23",
                        borderRadius: "5px",
                        padding: "6px 14px",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      }}
                      onClick={() => setIsOpen1(!isOpen1)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                      >
                        <path d="M4 3h2v10H4V3zm3 0h2v10H7V3zm3 0h2v10h-2V3z" />
                      </svg>
                    </button>
                    {isOpen1 && (
                      <div
                        className="dropdown-menu show p-2 shadow-sm bg-white"
                        style={{
                          width: "250px",
                          borderRadius: "5px",
                          fontSize: "12px",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className="fw-bold text-muted p-2 bg-light fs-12">
                          Default View
                        </div>
                        <div className="d-flex justify-content-between py-1 border-bottom bg-light">
                          <span className="fw-bold fs-12">Hidden</span>
                          <span
                            className="text-primary fs-12"
                            style={{ cursor: "pointer" }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleShowAllColumns();
                            }}
                          >
                            Show all
                          </span>
                        </div>
                        <ul className="list-unstyled px-2 fs-12">
                          {[
                            { key: "srNo", label: "Sr No" },
                            { key: "entity", label: "Entity" },
                            { key: "branch", label: "Branch ID" },
                            { key: "legislation", label: "Legislation" },
                            {
                              key: "complianceDetails",
                              label: "Compliance Description",
                            },
                            {
                              key: "dateOfCompliance",
                              label: "Date of Compliance",
                            },
                            { key: "dueDate", label: "Due Date" },
                            { key: "auditor", label: "Auditor" },
                            // { key: "action", label: "Action" },
                          ].map((col) => (
                            <li
                              key={col.key}
                              className="d-flex align-items-center py-1"
                              style={{ cursor: "pointer" }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleColumn(col.key);
                              }}
                            >
                              <span className="me-2 fs-12">⋮⋮</span>
                              {col.label}
                              <span className="ms-auto">
                                {visibleColumns[col.key] ? "👁️" : "🙈"}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  <div className="d-flex ">
                    <div className="">
                      <select
                        style={{ fontSize: "12px" }}
                        className="form-select mb-3 "
                        value={selectedCompany}
                        onChange={(e) => setSelectedCompany(e.target.value)}
                      >
                        <option value="" className="fs-12">
                          Select Company
                        </option>
                        {companies.map((company, idx) => (
                          <option key={idx} value={company} className="fs-12">
                            {company}
                          </option>
                        ))}
                      </select>



                      <input
                        type="hidden"
                        className="form-control mb-2 fs-12"
                        placeholder="Function Head Name"
                        value={functionHeadName}
                        onChange={(e) => setFunctionHeadName(e.target.value)}
                      />

                      <input
                        type="hidden"
                        className="form-control mb-3 fs-12"
                        placeholder="Designation"
                        value={designation}
                        onChange={(e) => setDesignation(e.target.value)}
                      />
                    </div>

                    {selectedCompany && (
                      <div
                        id="certificate-content"
                        style={{
                          position: "absolute",
                          left: "-9999px",
                          top: "0",
                          width: "794px",
                          padding: "50px",
                          background: "#fff",
                          fontFamily: "Times New Roman, serif",
                          fontSize: "12px",
                          lineHeight: "1.6",
                          color: "#000",
                        }}
                      >
                        <h2
                          style={{
                            textAlign: "center",
                            textTransform: "uppercase",
                            fontSize: "12px",
                          }}
                        >
                          COMPLIANCE CERTIFICATE
                        </h2>

                        <p className="fs-12">
                          Date:{" "}
                          <strong>
                            {new Date().toLocaleDateString("en-GB")}
                          </strong>
                        </p>
                        <p className="fs-12">
                          To <br />
                          Management - <strong>{selectedCompany}</strong>
                        </p>
                        <p className="fs-12">
                          {selectedCompany} -{" "}
                          <strong>{selectedSubBranches}</strong>
                        </p>
                        <p className="fs-12">
                          <strong>
                            Re: Certificate of Compliance with Applicable
                            Statutory Act.
                          </strong>
                        </p>

                        <p className="fs-12">
                          Dear Sir, <br />I declare that I am responsible for
                          ensuring compliance under the following laws applicable
                          to my domain during the period ended{" "}
                          <strong>
                            {startDate
                              ? startDate.toLocaleDateString("en-GB")
                              : "Start Date"}{" "}
                            to{" "}
                            {endDate
                              ? endDate.toLocaleDateString("en-GB")
                              : "End Date"}
                          </strong>
                        </p>

                        {/* ✅ Complied Acts Table */}
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginTop: "10px",
                          }}
                        >
                          <thead className="fs-12">
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  width: "60px",
                                  padding: "6px",
                                }}
                              >
                                S.No
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px",
                                }}
                              >
                                Name of the Statute / Act
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {companyReports
                              .filter(
                                (item) =>
                                  item.currentstatus === "Complied" &&
                                  isLocalDateInRange(item.dueDate, startDate, endDate)
                              )
                              .map((act, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {act.act}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>

                        {/* ✅ Non-Complied Acts Section */}
                        <p className="mt-4 fs-12">
                          I certify that all applicable compliances in reference
                          to above mentioned laws and the rules made thereunder
                          including without limitation maintenance of registers,
                          filing necessary returns, payment of necessary dues,
                          etc. with appropriate authorities, have been complied
                          with exception of following non–compliances thereto
                          except as stated below:
                        </p>

                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginTop: "10px",
                          }}
                        >
                          <thead className="fs-12">
                            <tr>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px",
                                }}
                              >
                                S.No
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px",
                                }}
                              >
                                Location
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px",
                                }}
                              >
                                Applicable Law
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  padding: "6px",
                                }}
                              >
                                Section & Provision
                              </th>
                              {/* <th style={{ border: "1px solid #000", padding: "6px" }}>Deviation / Non-Compliance</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {companyReports
                              .filter(
                                (item) =>
                                  item.currentstatus === "Not Complied" &&
                                  isLocalDateInRange(item.dueDate, startDate, endDate)
                              )
                              .map((nc, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {nc.branchName}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {nc.act}
                                  </td>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      padding: "6px",
                                    }}
                                  >
                                    {nc.provision}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        <br></br>
                        <p>
                          I have not done or committed any act or entered into any
                          transaction in violation of applicable laws and internal
                          company policies.
                        </p>
                        <br></br>
                        <p>
                          This certificate is given by the undersigned with full
                          knowledge that the Management of the {selectedCompany}{" "}
                          are fully relying on this representation.
                        </p>
                        <br></br>
                        <p>
                          I request you to take the above declaration on your
                          record.
                        </p>

                        <div style={{ marginTop: "60px" }}>
                          <p>_____________________________________</p>
                          <p>
                            <strong>
                              {JSON.parse(localStorage.getItem("name"))},<br />
                            </strong>
                          </p>
                          <p>
                            {designation}
                            <br />
                            {functionHeadName} <br />
                            Consultant <br />
                            Date: {new Date().toLocaleDateString("en-GB")}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>

                  <button
                    className="btn mb-3"
                    onClick={handleGeneratePDF}
                    disabled={!selectedCompany || companyActs.length === 0}
                    style={{
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "12px",
                    }}
                  >
                    <svg
                      width={14}
                      height={16}
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.99935 6.33333V11.3333M6.99935 11.3333L4.49935 8.83333M6.99935 11.3333L9.49935 8.83333M11.166 15.5H2.83268C1.91221 15.5 1.16602 14.7538 1.16602 13.8333V2.16667C1.16602 1.24619 1.91221 0.5 2.83268 0.5H7.4875C7.70852 0.5 7.92048 0.587797 8.07676 0.744078L12.5886 5.25592C12.7449 5.4122 12.8327 5.62416 12.8327 5.84518V13.8333C12.8327 14.7538 12.0865 15.5 11.166 15.5Z"
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Generate Certificate
                  </button>
                  <div className="d-flex gap-4">
                    <div
                      className="dropdown"
                      ref={dropdownRef}
                      style={{ position: "relative" }}
                    >
                      <button
                        className="d-flex align-items-center gap-2 fh"
                        onClick={toggleDropdown2}
                        style={{
                          border: "1px solid #E4E4E7",
                          backgroundColor: "#FFFFFF",
                          color: "#1F1F23",
                          borderRadius: "5px",
                          padding: "6px 14px",
                          fontSize: "14px",
                          fontWeight: "500",
                          boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                        }}
                      >
                        <svg
                          width={14}
                          height={16}
                          viewBox="0 0 14 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.99935 6.33333V11.3333M6.99935 11.3333L4.49935 8.83333M6.99935 11.3333L9.49935 8.83333M11.166 15.5H2.83268C1.91221 15.5 1.16602 14.7538 1.16602 13.8333V2.16667C1.16602 1.24619 1.91221 0.5 2.83268 0.5H7.4875C7.70852 0.5 7.92048 0.587797 8.07676 0.744078L12.5886 5.25592C12.7449 5.4122 12.8327 5.62416 12.8327 5.84518V13.8333C12.8327 14.7538 12.0865 15.5 11.166 15.5Z"
                            stroke="#1A1A33"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        Export
                      </button>

                      {showDropdown && (
                        <div
                          className="card shadow-sm"
                          style={{
                            width: "200px",
                            position: "absolute",
                            top: "100%",
                            right: "0",
                            transform: showDropdown
                              ? "translateX(0)"
                              : "translateX(100%)",
                            opacity: showDropdown ? 1 : 0,
                            transition:
                              "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
                            zIndex: 9999,
                            backgroundColor: "#fff",
                          }}
                        >

                          <div className="btn-group w-100 mt-2 px-2">
                            {["pdf", "excel"].map((f) => (
                              <button
                                key={f}
                                className={`btn ${format === f ? "btn-dark" : "btn-outline-dark"
                                  }`}
                                onClick={() => {
                                  setFormat(f);
                                  setPeriod(null);
                                }}
                              >
                                <i className={`bi bi-file-earmark-${f}`}></i>{" "}
                                {f.toUpperCase()}
                              </button>
                            ))}
                          </div>

                          {format && (
                            <div className="mt-3">


                            </div>
                          )}

                          {format && (
                            <div className="d-flex justify-content-end">
                              <button
                                className="btn btn-dark w-50 mt-3 mb-2 mx-2"
                                onClick={handleExport}
                              >
                                Export
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-scroll">
              <table className="table table-hover align-middle mt-0 rounded vertical-border">
                <thead className="bg-light text-nowrap fs-12 table-color">
                  <tr>

                    {visibleColumns.srNo && <th>Sr No</th>}
                    {visibleColumns.entity && <th>Entity</th>}
                    {visibleColumns.branch && <th>Branch ID</th>}
                    {visibleColumns.legislation && <th>Legislation</th>}
                    {visibleColumns.complianceDetails && (
                      <th>Compliance Details</th>
                    )}
                    {visibleColumns.dateOfCompliance && (
                      <th>Date of Compliance</th>
                    )}
                    {visibleColumns.score && <th>Score</th>}
                    {visibleColumns.dueDate && <th>Due Date</th>}
                    {visibleColumns.auditor && <th>Auditor</th>}
                    {visibleColumns.complianceStatus && (
                      <th>Compliance Status</th>
                    )}
                  </tr>
                </thead>
                <tbody className="fs-12">
                  {currentReports?.map((item, index) => (
                    <tr key={index}>

                      {visibleColumns.srNo && <td>{index + 1}</td>}
                      {visibleColumns.entity && <td>{item.companyName}</td>}
                      {visibleColumns.branch && <td>{item.branchName}</td>}
                      {visibleColumns.legislation && <td>{item.act}</td>}
                      {visibleColumns.complianceDetails && (
                        <td>
                          {item.compd}{" "}
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              padding: 0,
                              marginLeft: "5px",
                              cursor: "pointer",
                              color: "#0d6efd",
                            }}
                            onClick={() => {
                              setComplianceData(item); // store row data
                              setShowModall(true);
                            }}
                            className="btn btn-sm btn-outline-primary"
                            title="View Compliance"
                          >
                            <VisibilityIcon fontSize="small" />
                          </button>
                        </td>
                      )}
                      {visibleColumns.dateOfCompliance && (
                        <td>
                          {item?.period
                            ? new Date(item.period)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .replace(/ (\w{3}) /, " $1, ")
                            : "NA"}
                        </td>
                      )}
                      {visibleColumns.score && (
                        <td>
                          {item.currentstatus === "Complied"
                            ? "1"
                            : item.currentstatus === "Not Complied"
                              ? "0"
                              : item.currentstatus === "Partial Complied"
                                ? "0.5"
                                : item.currentstatus === "Not Applicable"
                                  ? "0"
                                  : "-"}
                        </td>
                      )}
                      {visibleColumns.dueDate && (
                        <td>
                          {item?.dueDate
                            ? (() => {
                              const dueDate = new Date(item.dueDate);
                              const today = new Date();
                              const diffTime = dueDate - today;
                              let diffDays = Math.ceil(
                                diffTime / (1000 * 60 * 60 * 24)
                              );

                              const formattedDate = dueDate
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .replace(/ (\w{3}) /, " $1, ");

                              if (diffDays < 0) diffDays = 0;

                              // Blinking style for only days part
                              let blinkClass = "blink ";
                              if (diffDays > 0) {
                                blinkClass += "text-green-600";
                              } else {
                                blinkClass += "text-red-600";
                              }

                              return (
                                <span>
                                  {formattedDate}{" "}
                                  {item.currentstatus !== "Complied" && (
                                    <span className={blinkClass}>
                                      ({diffDays} days to go)
                                    </span>
                                  )}
                                </span>
                              );
                            })()
                            : "NA"}
                        </td>
                      )}
                      {visibleColumns.auditor && (
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ fontSize: "14px", fontWeight: 500 }}>
                              {item.assignedAuditor}
                            </span>
                          </div>
                        </td>
                      )}
                      {visibleColumns.complianceStatus && (
                        <td>
                          <div
                            style={{
                              display: "inline-block",
                              backgroundColor:
                                item.currentstatus === "Complied"
                                  ? "rgba(232, 255, 236, 1)"
                                  : item.currentstatus === "Partial Complied"
                                    ? "rgba(255, 244, 217, 1)"
                                    : item.currentstatus === "Not Complied"
                                      ? "rgba(255, 204, 204, 1)"
                                      : item.currentstatus === "Not Applicable"
                                        ? "#9ba0a3ff"
                                        : "rgba(255, 229, 198, 1)",

                              border:
                                item.currentstatus === "Complied"
                                  ? "1px solid rgba(39, 181, 147, 1)"
                                  : item.currentstatus === "Partial Complied"
                                    ? "1px solid rgba(249, 193, 50, 1)"
                                    : item.currentstatus === "Not Complied"
                                      ? "1px solid rgba(252, 68, 99, 1)"
                                      : item.currentstatus === "Not Applicable"
                                        ? "1px solid #6C757D"
                                        : "1px solid rgba(255, 140, 0, 1)",

                              color: "rgba(26, 26, 51, 1)",
                              padding: "4px 10px",
                              borderRadius: "4px",
                              // fontWeight: "bold",
                              fontSize: "12px",
                            }}

                          >
                            {item.currentstatus}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              </div>
              {/* Blink & Colors */}
              <style>
                {`
          @keyframes blink { 50% { opacity: 0; } }
          .blink { animation: blink 2s step-start infinite; font-weight: bold; }
          .text-green-600 { color: #16a34a; }
          .text-red-600 { color: #dc2626; }
        `}
              </style>
              <div className="d-flex justify-content-between align-items-center mt-4">
                <div>
                  <select
                    className="form-select form-select-sm w-auto fs-12"
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1); // Reset to first page
                    }}
                  >
                    <option value={10} className="fs-12">
                      10 rows
                    </option>
                    <option value={20} className="fs-12">
                      20 rows
                    </option>
                    <option value={30} className="fs-12">
                      30 rows
                    </option>
                  </select>
                </div>

                {showModall && complianceData && (
                  <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    style={{ background: "rgba(0,0,0,0.5)" }}
                  >
                    <div className="modal-dialog modal-lg">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Compliance Details</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowModall(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <p>
                            <strong>Description:</strong>{" "}
                            {complianceData.desc || "NA"}
                          </p>
                          <p>
                            <strong>Penalty Type:</strong>{" "}
                            {complianceData.penalty_type || "NA"}
                          </p>
                          <p>
                            <strong>Penalty:</strong>{" "}
                            {complianceData.penalty_description || "NA"}
                          </p>
                        </div>
                        <div className="modal-footer">
                          <button
                            className="btn btn-secondary"
                            onClick={() => setShowModall(false)}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <nav>
                  <ul className="pagination mb-0 d-flex align-items-center gap-2">
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""
                        }`}
                    >
                      <button
                        className="page-link text-dark border-0 bg-transparent fs-12"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        Previous
                      </button>
                    </li>

                    {pageNumbers.map((page, index) => (
                      <li
                        key={index}
                        className={`page-item ${page === currentPage ? "active" : ""
                          }`}
                      >
                        {page === "..." ? (
                          <span className="page-link text-dark border-0 bg-transparent">
                            ...
                          </span>
                        ) : (
                          <button
                            className={`page-link d-flex align-items-center justify-content-center fw-bold rounded-circle circle ${page === currentPage
                              ? "bg-dark text-white"
                              : "text-dark bg-transparent"
                              } border-0`}

                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </li>
                    ))}

                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""
                        }`}
                    >
                      <button
                        className="page-link text-dark border-0 bg-transparent"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default CompliancerReports;
